define [], () ->
  ($scope, $uibModalInstance, Landlord, Flash) ->
    $scope.processing = false
    $scope.forgetCard = () ->
      $scope.processing = true
      Landlord.remove_card().$promise.then ->
         $uibModalInstance.close(true)
         $scope.processing = false



// WEBPACK FOOTER //
// ./components/dashboard/view/ForgetCardPopup.coffee